<template>
  <div id="app">
    <keep-alive>
      <router-view :width="width"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    //这里存放数据
    return {
      show: false,
      width: '',
    }
  },
  mounted() {
    if (localStorage.getItem('client_id')) {
      this.websocket.Init()
    }
  },
  created() {

  },
  methods: {
    getContact(id) {
      let contacts = JSON.parse(localStorage.getItem('allContacts'));
      if (!id) {
        return contacts;
      } else {
        const contact = contacts.find(obj => obj.id == id);
        return contact;
      }
    }
  }
}
</script>

<style lang="less">
#app {
  background-color: #fff;
}

* {
  padding: 0;
  bottom: 0;
}

body {
  /* 顶部预留安全区域 */
  padding-top: constant(safe-area-inset-top);
  /* 兼容iOS < 11.2 */
  padding-top: env(safe-area-inset-top);
  /* 标准语法 */

  /* 底部预留安全区域（如需要） */
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

img {
  max-width: 100% !important;
  height: auto;
}

.el-message {
  height: 50px;
  /* 使用 !important 确保优先级 */
}

/* 去掉文本框的右边拉伸 */
.el-textarea__inner {
  resize: none !important;
}

.el-dialog {
  background: transparent !important;
  box-shadow: none !important;
  border: none;
}

/* 弹出框 */
.el-dialog__wrapper {
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-dialog__header {
    height: 0;
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog {
    border-radius: 10px;
    overflow: hidden;
    margin-top: 0 !important;
  }
}

.custom-loading {

  .el-loading-spinner i,
  .el-loading-spinner .el-loading-text {
    color: #FE64BA;
  }
}
</style>
